import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';
import Breakpoints from '../../design-utils/breakpoints';

const helpers = createMultiStyleConfigHelpers([
  'slidePanelBackdrop',
  'slidePanelContainer',
  'infoWrapper',
  'slidePanelHeader',
  'closeButton',
  'imageContainer',
  'imageEmptyState',
  'productTitleContainer',
  'divider',
  'price',
  'reviewsContainer',
  'starsContainer',
  'reviewsCount',
  'closeIcon',
]);

const SlidePanel = helpers.defineMultiStyleConfig({
  baseStyle: {
    slidePanelBackdrop: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(89, 89, 94, 0.5)',
      zIndex: 10050,
      '&:empty': {
        display: 'block',
      },
    },
    slidePanelContainer: {
      height: '100vh',
      position: 'fixed',
      top: 0,
      right: 0,
      backgroundColor: '#ffffff',
      zIndex: 10100,
      display: 'none',
      [`&[data-is-open="true"]`]: {
        display: 'flex',
      },
      flexDirection: ' column',
      [`@media screen and (min-width: ${Breakpoints.sm})`]: {
        width: '336px',
      },
      [`@media screen and (max-width: ${Breakpoints.lg})`]: {
        width: '100%',
      },
      width: '336px',
      '*:empty': {
        display: 'block',
      },
    },
    infoWrapper: {
      height: '100%',
      overflowY: 'auto',
      padding: '28px 10px',
      width: '100%',
    },
    slidePanelHeader: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
    },
    closeButton: {
      backgroundColor: 'transparent',
      borderRadius: '50%',
      border: 'none',
    },
    closeIcon: {
      width: '24px',
      height: '24px',
    },
    imageContainer: {
      display: 'inline-block',
      width: '100%',
      marginTop: '15px',
      borderRadius: '8px',
    },
    imageEmptyState: {
      width: '280px',
      height: '323px',
      borderRadius: '8px',
      backgroundColor: '#dfe3e8',
      position: 'relative',
      '&:empty': {
        display: ' block',
      },
    },
    productTitleContainer: {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      textAlign: 'center',
      marginTop: '12px',

      '> p': {
        marginBottom: '8px',
      },

      '> p + p': {
        marginBottom: '22px',
      },
    },
    divider: {
      border: '1px solid #f1f2f3',
      margin: '24px 0',
    },
    price: {
      display: 'flex',
      justifyContent: 'space-evenly',
      alignItems: 'baseline',
    },
    reviewsContainer: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    starsContainer: {
      display: 'flex',
      justifyContent: ' center',
      alignItems: 'center',
      margin: '0.5rem auto',
      fontSize: '1.7rem',
    },
    starIcon: {
      fill: '#ffc600',
    },
    reviewsCount: {
      fontSize: '1.2rem',
      color: 'var(--grey)',
      textDecoration: 'underline',
    },
  },
  sizes: {},
  variants: {},
  defaultProps: {},
});

export default SlidePanel;
